// extracted by mini-css-extract-plugin
export default {"tabsStyle":"CostTrend_tabsStyle__XIyB6"};